import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { CUSTOM_PLAN_INDEX } from '../data/payment-types';
import { getEmailOrCallText, emailOrCallHome } from '../data/emailOrCallHome';

export default ({
  flag,
  title,
  blurb,
  pricing,
  qualitiesTitle,
  listOfQualities,
  onPlanSelected,
  index,
}) => (
  <div className={flag ? 'green-outline' : ''}>
    {flag ? (
      <div className="payment-card-emphasis centered-content header-text">{flag}</div>
    ) : (
      <div className="payment-card-emphasis-empty" />
    )}
    <div className="payment-card">
      <div className={`payment-card-title header-text ${flag ? 'squared-top-radius' : ''}`}>
        <h2>{title}</h2>
        <p className="payment-card-blurb">{blurb}</p>
      </div>
      <div className="payment-card-description">
        <p dangerouslySetInnerHTML={{ __html: pricing.description }} />
        <p>{pricing.subdescription}</p>
      </div>
      <div className="payment-card-items">
        <h3>{qualitiesTitle}</h3>
        {listOfQualities.map(quality => {
          return (
            <div className="payment-card-item body-text" key={quality}>
              <Icon size="large" name="check" className="payment-card-item-icon" />
              <p>{quality}</p>
            </div>
          );
        })}
      </div>
      <div className="payment-card-cta">
        {index === CUSTOM_PLAN_INDEX ? (
          <Button className="select" content={getEmailOrCallText()} onClick={emailOrCallHome} />
        ) : (
          <Button className="select" content="Select Plan" onClick={() => onPlanSelected(index)} />
        )}
      </div>
    </div>
  </div>
);
